<div class="configuration-fields">
    <ng-container #outlet>
    </ng-container>
    <ng-template #content>
        <form [formGroup]="form" *ngIf="editFace">
            <form-item-component *ngIf="!customEditComponent"
                    [formulario]="form" 
                    [formConfiguration]="formItemConfiguration"  
                    [editData]="editData"
                    (saving)="onSavingArray($event)"
                    (canceling)="onCanceling($event)">
            </form-item-component>
        </form> 
        <div [hidden]="editFace" class="grid-face">
            <div class="tool-bar">
                <button nz-button nzType="primary" nzShape="circle" nz-tooltip="Adicionar" (click)="add()">
                    <nz-icon nzType="plus"></nz-icon>
                </button>
                <button nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip="Remover" (click)="remove()">
                    <nz-icon nzType="delete"></nz-icon>
                </button>
            </div>
                <div class="fields-grid">
                    <ag-grid-angular
                        style="width: 100%; height: 100%"
                        [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                        [rowData]="rows"
                        [getRowId]="getRowId"
                        [columnDefs]="displayedColumns"
                        (gridReady)="onGridReady($event)"
                        (rowDoubleClicked)="selectRow($event)"
                        (rowClicked)="eventGridSelect($event)"
                        (columnResized)="onResize($event)"
                        (columnMoved)="onReoder($event)"
                        [localeText]="ls.getCurrentGridLocale()"
                        overlayNoRowsTemplate="Não encontrado nenhum resultado"
                        rowBuffer="150"
                        rowSelection="multiple"
                        cacheBlockSize= "100"
                        cacheOverflowSize="2"
                        maxBlocksInCache= 10
                        resizable="true"
                        [pagination]="false"
                        [enableCellTextSelection]="true"
                        [suppressClipboardPaste]="true"
                        [multiSortKey]="true">
                    </ag-grid-angular>
                </div>
        </div>
    </ng-template>
</div>

